module.exports = __webpack_public_path__ + "img/kommune-541.7ad94bf6.svg";